<po-page-dynamic-table p-title="Processamento de Relatórios - Domínio" [p-table-custom-actions]="tableCustomActions"
  [p-page-custom-actions]="pageActions"
  [p-breadcrumb]="breadcrumb" [p-concat-filters]="true" [p-infinite-scroll]="true" [p-service-api]="serviceApi"
  [p-actions]="actions" [p-fields]="fields" [p-hide-columns-manager]="true" [p-actions-right]="false">

</po-page-dynamic-table>


<po-modal #modalRequestreport p-size="xl" p-title="Geração de Relatórios" p-icon="an an-tray-arrow-down"
  p-click-out="false">

  <!-- Summary -->
  <div class="modal-summary">
    <div class="modal-summary-icon"><i class="an an-newspaper"></i></div>
    <div class="modal-summary-text">
      <p class="modal-summary-title">Requisição de Processamento</p>
      <p class="modal-summary-hint">Selecione os relatórios que deseja processar e defina o período de referência.</p>
    </div>
  </div>

  <!-- Seleção de relatórios -->
  <div class="modal-section po-mt-3">
    <div class="modal-section-header">
      <i class="an an-list-checks"></i>
      <span>Relatórios Disponíveis</span>
    </div>
    <div class="modal-section-body">
      <div class="po-row">
        <po-checkbox-group #CndGroup class="po-lg-12" name="system" p-label="Selecione os relatórios"
          [p-options]="systemOptions">
        </po-checkbox-group>
      </div>
    </div>
  </div>

  <!-- Período -->
  <div class="modal-section po-mt-3">
    <div class="modal-section-header">
      <i class="an an-calendar"></i>
      <span>Período de Processamento</span>
    </div>
    <div class="modal-section-body">
      <div class="po-row">
        <po-datepicker-range #datepickerRange name="datepickerRange" class="po-lg-4 po-md-6 po-sm-12"
          p-label="Data Processamento" name="datepickerRange"
          p-help="Selecione o período de processamento dos relatórios.">
        </po-datepicker-range>
      </div>
    </div>
  </div>

  <!-- Aviso -->
  <div class="modal-notice po-mt-3">
    <i class="an an-info po-mr-2"></i>
    Os arquivos são processados e disponibilizados conforme disponibilidade dos RPAs de automação registrados no sistema.
  </div>

  <po-modal-footer>
    <po-button p-label="Cancelar" p-kind="secondary" (p-click)="poModalComponent.close()"> </po-button>
    <po-button p-label="Processar" p-kind="primary" (p-click)="requestReport()"> </po-button>
  </po-modal-footer>
</po-modal>
